// Password minimum complexity tests
const REG_UPPER = /[A-Z]/;
const REG_LOWER = /[a-z]/;
const REG_NUM = /[0-9]/;

export default function isPasswordStrengthEnough(password: string): boolean {
  if (
    REG_UPPER.test(password) &&
    REG_LOWER.test(password) &&
    REG_NUM.test(password) &&
    password.length > 7
  ) {
    return true;
  } else {
    return false;
  }
}
